exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/app/shared/view-video-modal/view-video-modal.component.css
// module id = ../../../../../src/app/shared/view-video-modal/view-video-modal.component.css
// module chunks = main